module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ARC","short_name":"ARC","background_color":"#33323C","theme_color":"#D7182A","display":"standalone","icon":"./static/icons/favicon-32x32.png","icons":[{"src":"./static/icons/icon-192x192.png","type":"image/png","sizes":"192x192"},{"src":"./static/icons/icon-512x512.png","type":"image/png","sizes":"512x512"}],"start_url":"/","scope":"/","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0ef74b2dc8a80c7ef8f3d5bdbf76b948"},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-redux/gatsby-browser.js'),
      options: {"plugins":[],"pathToCreateStoreModule":"./src/state/index","serialize":{"space":0,"isJSON":true,"unsafe":false}},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
